/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { accountManagement } from '@/api/ajax';

export default [
  {
    width: 180,
    label: '子账号名',
    tip: '请输入关键字',
    key: 'userName',
    id: 'userName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '项目名称',
    tip: '请输入项目名称',
    key: 'projectName',
    id: 'projectName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '项目编码',
    tip: '请输入项目编码',
    key: 'projectNo',
    id: 'projectNo',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '用户名',
    tip: '请输入关键字',
    key: 'subAccountName',
    id: 'subAccountName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '姓名',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'fullName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '工业方名称',
    tip: '工业方名称',
    key: 'industryEnterpriseId',
    id: 'industryEnterpriseId',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: accountManagement.obtainIndustryEnterprise,
    prop: {
      label: 'enterpriseName',
      code: 'id'
    },
    ajaxQuery: 'industryEnterpriseName'
  },
  {
    width: 180,
    tip: '操作',
    key: 'optionType',
    id: 'optionType',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: accountManagement.listLogType,
    prop: {
      label: 'name',
      code: 'key'
    },
    ajaxQuery: 'name'
  },
  {
    width: 180,
    label: '联系方式',
    tip: '请输入联系方式',
    key: 'phone',
    id: 'phone',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '部门',
    tip: '请输入部门',
    key: 'department',
    id: 'department',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '职位',
    tip: '请输入职位',
    key: 'position',
    id: 'position',
    slot: 'input',
    clearable: true
  },
  {
    id: 'createDt',
    width: 180,
    tip: '创建时间',
    label: '创建时间',
    key: 'createDt',
    slot: 'daterange',
    type: 'daterange'
  },
  {
    id: 'happendTime',
    width: 180,
    tip: '发生时间',
    label: '发生时间',
    slot: 'daterange',
    type: 'daterange',
    key: ['startTime', 'endTime'],
    text: ['发生时间始', '发生时间止']
  },
  {
    id: 'dealTimeStart',
    width: 180,
    tip: '执行开始时间',
    label: '执行开始时间',
    slot: 'date',
    type: 'month',
    key: 'startDt',
    text: '执行开始时间'
  },
  {
    id: 'dealTimeEnd',
    width: 180,
    tip: '执行结束时间',
    label: '执行结束时间',
    slot: 'date',
    type: 'month',
    key: 'endDt',
    text: '执行结束时间'
  },
  {
    id: 'dealTime',
    width: 180,
    tip: '执行发生时间',
    label: '执行发生时间',
    slot: 'daterange',
    type: 'daterange',
    key: ['startDt', 'endDt'],
    text: ['执行开始时间', '执行结束时间']
  },
  {
    width: 180,
    label: '启用状态',
    tip: '请选择启用状态',
    key: 'status',
    id: 'status',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '全部',
        key: ''
      },
      {
        name: '启用',
        key: 1
      },
      {
        name: '禁用',
        key: 2
      }
    ]
  },
  {
    width: 180,
    label: '分配状态',
    tip: '请选择分配状态',
    key: 'distributionState',
    id: 'distributionState',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '未分配',
        key: 0
      },
      {
        name: '已分配',
        key: 1
      }
    ]
  },
  {
    width: 180,
    label: '项目状态',
    tip: '请选择项目状态',
    key: 'projectStatus',
    id: 'projectStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '未完结',
        key: 0
      },
      {
        name: '已完结',
        key: 1
      }
    ]
  },
  {
    width: 180,
    tip: '请选择订单类型',
    key: 'invoiceOrderType',
    id: 'invoiceOrderType',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '支付订单',
        key: 1
      },
      {
        name: '综合服务费',
        key: 2
      }
    ]
  },
  {
    width: 180,
    label: '当前交易结构',
    tip: '请选择',
    key: 'taxCollectionPattern',
    id: 'taxCollectionPattern',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '汇总申报',
        key: 1
      },
      {
        name: '委托代开',
        key: 2
      },
      {
        name: '委托代发',
        key: 3
      },
      {
        name: '运营基地',
        key: 4
      },
      {
        name: '委托代开(线上)',
        key: 6
      },
      {
        name: '工具',
        key: 9
      }
    ]
  }
];
